// extracted by mini-css-extract-plugin
export default {"toggle":"ViewModeToggle_toggle__ZkwaI","option":"ViewModeToggle_option__+f2dT","optionActive":"ViewModeToggle_optionActive__lhrXO"};